import React, { useEffect, useState } from "react";
import NavigationBar from "components/NavigationBar";
import Sidebar from "./SideBar";
import Breadcrumb from "./Breadcrumb";
import { connect } from "react-redux";
import ErrorHandler from "components/ErrorHandler";
import ErrorService from "services/ErrorService";

const MainWrapper = (props: any) => {
  const { breadcrumbs } = props || {};
  const height =
    breadcrumbs?.length > 0 ? "calc(100vh - 137px)" : "calc(100vh - 60px)";
  const [width, setWidth] = useState("100%");
  return (
    <div style={styles.col}>
      <NavigationBar />
      <div style={styles.row}>
        <Sidebar />
        <div style={{ ...styles.col, width }}>
          <Breadcrumb />
          <main id="app" style={{ height }}>
            {props.children}
          </main>
        </div>
      </div>
      <ErrorHandler ref={(ref) => (ErrorService.errRef = ref)} />
    </div>
  );
};

const styles: { [name: string]: React.CSSProperties } = {
  row: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  col: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
};

const mapStateToProps = (state: any) => {
  return {
    breadcrumbs: state.breadcrumb.data,
  };
};

export default connect(mapStateToProps)(MainWrapper);
